import { render } from "./AdminOrderSummary.vue?vue&type=template&id=12fa975e"
import script from "./AdminOrderSummary.vue?vue&type=script&lang=js"
export * from "./AdminOrderSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__